<template>
  <div id="IndicationsList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" v-model="searchFrom.indicationsName" type="text" placeholder="适应症">
          </p>


          <button @click="getTagList(1)" class="redButtonTwo">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="newTopic">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div style="overflow:auto; width: 100%;">
        <table cellspacing="0" class="allTable" :style="tagList.length > 0 ? 'width: 100%;' : 'width: 100%;'">
          <thead>
          <tr>
            <th class="t_c">适应症</th>
            <th class="t_c">领域</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="tagList.length > 0">
              <tr :key="index" v-for="(item, index) in tagList">
                <td width="10%" class="t_c NoWrap"  :title="item.indicationsName">{{item.indicationsName}}</td>
                <td width="10%" class="t_c NoWrap"  :title="item.fieldName">{{item.fieldName}}</td>
                <td width="15%" class="t_c">
                  <div class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="editTag(item)">编辑</li>
                      <li @click="deleteTag(item)">删除</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getTagList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    
    <!-- 新建标签 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="height:250px;width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>适应症</span>
            <input v-model="addFrom.name" maxlength="50"  type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入适应症" />
          </li>


          <li>
              <span style="font-size:16px;"><i class="colorRed m_r_5">*</i>领域</span>
                <abbr class="d_i" >
                  <allSelect style="margin-left: -30px;" :chooseData="IndicationsList" :needReturn="'id'" :placeholder="'领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="addFrom.fieldId">
                  </allSelect>
                </abbr>
            </li>

        </ul>
      </div>
    </model>
      
  </div>
</template>
<script>
export default {
  name: 'indicationsList',
 data () {
  return {
    searchFrom:{
      indicationsName:''
    },
    addFrom:{
      name:'',
      fieldId:null
    },
    tagList:[],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      totalCount: 0,
      showModel:false,
      modelTitle:'',
      id:null,
      IndicationsList:[]
  }
 },
 created () {
  this.getIndicationsList()
  this.getDemoDatas()
 },
 methods: {
  getIndicationsList(){
    this.$axiox.get(`/api/Dict/GetFields`).then(res => {
      console.log('下拉',res)
        this.IndicationsList = res
      })
  },
  getDemoDatas(){
    let params = {
        pageIndex: 1,
        pageSize: 10
      }

      this.page=1
      this.pageSize= 10
      this.totalPage=0
      this.totalCount= 0

      const data = {
        indicationsName:''
      }
      let url = this.$commonJs.returnQuery('/api/indications/GetIndicationsList', data)

    this.$axiox.post(url, params).then(res => {
        console.log(res, '获取话题列表')
        if (res && res.data.length > 0) {
          this.tagList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.tagList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
  },
  getTagList (page) {
    
      this.page = page
      let data = JSON.parse(JSON.stringify(this.searchFrom))
      console.log(data)

      let params = {
        pageIndex: page,
        pageSize: this.pageSize
      }
      // 转义
      // let url = this.$commonJs.returnQuery('/api/topic/GetTopicsList', data)
      // this.$axiox.post(url, params).then(res => {
        this.$axiox.post('/api/indications/GetIndicationsList', {
          indicationsName:this.searchFrom.indicationsName,
          pageIndex: page,
          pageSize: this.pageSize
        }).then(res => {
        console.log(res, '获取适应症列表')
        if (res && res.data.length > 0) {
          this.tagList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.tagList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    newTopic(){
      this.getIndicationsList()
      this.id = null
      this.addFrom={
        name:'',
        fieldId:null
        }
      this.modelTitle = '新建适应症'
      
      this.showModel = true
    },
    confirModel(){
      if(!this.addFrom.name||!this.addFrom.fieldId){
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return false
      }

      if(this.id){
        const objs = {
          id:this.id,
          name:this.addFrom.name,
          fieldId:this.addFrom.fieldId
        }

        this.$axiox.post('/api/indications/UpdIndications', objs).then(res => {
        if (res.data) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '编辑成功',
            stayTime: 5
          })
          this.showModel = false
          this.getDemoDatas()
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res.message || '请检查必填项',
            stayTime: 5
          })
        }
      })


      }else{
        const objs = this.addFrom
        
        this.$axiox.post('/api/indications/AddIndications', objs).then(res => {
          
          console.log('resssssss',res)

        if (res.data) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新建成功',
            stayTime: 5
          })
          this.showModel = false
          this.getDemoDatas()
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res.message || '请检查必填项',
            stayTime: 5
          })
        }
      })
      }

      
    },
    cancelModel(){
      this.id = null
      this.showModel = false
      this.addFrom={
          name:'',
          fieldId:null
        }
    },
    deleteTag(item){

      this.$commonJs.doubleComfirm({
        content: '是否确定删除此标签？',
        successFun: msg => {
          this.$axiox.get('/api/indications/DeleteIndications?topicId=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getDemoDatas()
          })
        },
        errorFun: msg => {
        }
      })

    },
    editTag(item){
      this.modelTitle = '编辑话题'
      this.addFrom={
          name:item.indicationsName,
          fieldId:item.fieldId
        }
        this.id = item.id
      this.showModel = true
    }
 }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/IndicationsManager/IndicationsList.vue